// React
import { ReactElement } from 'react';
// Modules
import classNames from 'classnames/bind';
// Design System
import { Font } from '@utmb/design-system/text/font';
// Styles
import styles from './information.module.scss';

const cx = classNames.bind(styles);

export const Information = (props: { classNameValue?: string; label: string; value?: string; children?: any }): ReactElement => {
    const { classNameValue, label, value, children } = props;

    const valueCSS = cx(styles.value, classNameValue);

    return (
        <div className={styles.container}>
            <Font.OxaniumRegular className={styles.label} mobile="12" desktop="12" as="span">
                {label}
            </Font.OxaniumRegular>
            {!children && value ? (
                <Font.OxaniumBold className={valueCSS} mobile="16" desktop="18" as="span">
                    {value}
                </Font.OxaniumBold>
            ) : (
                <Font.OxaniumBold className={valueCSS} mobile="16" desktop="18" as="span">
                    {children}
                </Font.OxaniumBold>
            )}
        </div>
    );
};
